import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import EditIcon from "@material-ui/icons/Edit";
import DoneIcon from "@material-ui/icons/Done";
import DeleteModal from "../../ui/DeleteModal";
import { useDispatch, useSelector } from "react-redux";
import { updateArea, addNewArea } from "../../../store/area/areaActions";
import AddIcon from "@material-ui/icons/Add";
import ManageArea from "./ManageArea";
import { Container, Fab, Typography,Tooltip } from "@material-ui/core";
import { formatHolidays } from "../../util/csvHelpers";
import { setDefaultArea } from "../../../store/area/areaActions";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.common.white,
    fontSize: 16,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.grey[100],
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  createButton: {
    position: "absolute",
    bottom: theme.spacing(12),
    right: theme.spacing(4),
  },
  tableContainer: {
    maxHeight: 600,
  },
}));

const tableheader = [
  { name: "Name EN", key: "name_en", type: "text" },
  { name: "Name Ar", key: "name_ar", type: "text" },
  { name: "Enabled", key: "enabled", type: "switch" },
  { name: "Min SLA", key: "min_sla", type: "text" },
  { name: "Max SLA", key: "max_sla", type: "text" },
  { name: "Holiday", key: "holiday", type: "text" },
  { name: "Fast Delivery", key: "fast_delivery", type: "switch" },
  { name: "Fast Delivery Type", key: "fast_delivery_type", type: "text" }
];

const tableheaderNew = [
  { name: "Name EN", key: "name_en", type: "text" },
  { name: "Name Ar", key: "name_ar", type: "text" },
  { name: "Enabled", key: "enabled", type: "switch" },
  { name: "Min SLA", key: "min_sla", type: "text" },
  { name: "Max SLA", key: "max_sla", type: "text" },
  { name: "COD Verification", key: "cod_verification", type: "switch" },
  { name: "Min Threshold Amount", key: "threshold", type: "text" },
  { name: "Max Threshold Amount", key: "max_threshold", type: "text" },
  { name: "Holiday", key: "holiday", type: "text" },
  { name: "Fast Delivery", key: "fast_delivery", type: "switch" },
  { name: "Fast Delivery Type", key: "fast_delivery_type", type: "text" }
];

export default function AreaListTable(props) {
  const isGulf = localStorage.getItem("region") === "GULF";
  const tableHeader = isGulf ? tableheader : tableheaderNew;
  const dispatch = useDispatch();
  const classes = useStyles();
  const [state, setState] = React.useState({
    deleteAction: false,
    editAction: false,
    createAction: false,
    selectedItem: null,
    createItem: {
      id: 0,
      name_en: "",
      name_ar: "",
      enabled: true,
      min_sla: 0,
      max_sla: 0,
      fast_delivery: false,
      cod_verification: false,
      threshold: 0,
      max_threshold: 0,
      holiday: ""
    },
  });
  const defaultArea = (e, data) => {
    e.stopPropagation();
    dispatch(setDefaultArea(data));
  };
  const editRow = (event, data) => {
    event.stopPropagation();
    setState({
      ...state,
      editAction: true,
      deleteAction: false,
      selectedItem: data,
    });
  };

  const closeModal = (name) => {
    setState({ ...state, [name]: false });
  };

  const updateAreaHandler = (area) => {
    dispatch(updateArea(area));
    closeModal("editAction");
  };

  const createAreaAction = (area) => {
    dispatch(addNewArea(area));
    closeModal("createAction");
  };

  const openCreateModal = () => {
    setState({ ...state, createAction: true });
  };
  const modalPopUp = () => {
    if (state.deleteAction) {
      return (
        <DeleteModal
          open={state.deleteAction}
          close={() => closeModal("deleteAction")}
          title={state.selectedItem.title}
          deleteConfirmation={props.deleteAPICall}
        />
      );
    } else if (state.editAction) {
      return (
        <ManageArea
          headerMessage="Update Area/Pincode"
          open={state.editAction}
          close={() => closeModal("editAction")}
          data={state.selectedItem}
          actionHandler={updateAreaHandler}
          holidays={props.holidays}
          deliveryoption={props.deliveryList}
        />
      );
    } else if (state.createAction) {
      return (
        <ManageArea
          headerMessage="Add New Area/Pincode"
          open={state.createAction}
          close={() => closeModal("createAction")}
          data={state.createItem}
          actionHandler={createAreaAction}
          holidays={props.holidays}
          deliveryoption={props.deliveryList}
        />
      );
    }
  };

  const tabledoby = ({ selectedWarehouse, holidays }) => {
    const lastMileSla = (last_mile_sla) => last_mile_sla?.find(sla => sla.warehouse === selectedWarehouse)
    if (props.tabaledata) {
      return props.tabaledata.map((data) => (
        <StyledTableRow key={data.id} hover>
          {tableHeader.map((cell, index) => {
            const lastMileSlaData = lastMileSla(data.last_mile_sla)
            return (
              <TableCell align="left" key={index}>
                {cell.type === "switch" ? data[cell.key] + ""
                : (cell.key === "min_sla" && lastMileSlaData?.min_sla) ? lastMileSlaData.min_sla
                : (cell.key === "max_sla" && lastMileSlaData?.max_sla) ? lastMileSlaData.max_sla
                : cell.key === "holiday" && data?.[cell.key]?.length > 0 ? formatHolidays(data[cell.key], holidays)
                : data[cell.key]}
              </TableCell>
            )
          })}
          <TableCell>
            <Tooltip title="Edit Area">
            <Fab
              color="default"
              aria-label="edit"
              size="small"
              variant="extended"
              onClick={(event) => editRow(event, data)}
            >
              <EditIcon color="primary" />
             
            </Fab>
            </Tooltip>
            <Tooltip title="Set As Default">
              <Fab
                color="default"
                aria-label="edit"
                size="small"
                variant="extended"
                onClick={(e) => defaultArea(e, data)}
              >
                <DoneIcon color="secondary" />
              </Fab>
            </Tooltip>
          </TableCell>
        </StyledTableRow>
      ));
    } else {
      <div>No data found</div>;
    }
  };

  const selectedWarehouse = localStorage.getItem("warehouse");

  return (
    <React.Fragment>
      <Container maxWidth="xl">
        <Fab
          color="primary"
          aria-label="add"
          onClick={openCreateModal}
          className={classes.createButton}
        >
          <AddIcon />
        </Fab>
        <Typography variant="subtitle2" gutterBottom align="left">
          Area/Pincode
        </Typography>
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table
            stickyHeader
            className={classes.table}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow>
                {tableHeader.map((row) => (
                  <StyledTableCell align="left" key={row.name}>
                    {row.name}
                  </StyledTableCell>
                ))}
                <StyledTableCell align="left">Action</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>{tabledoby({ selectedWarehouse, holidays: props.holidays })}</TableBody>
          </Table>
        </TableContainer>
      </Container>
      {modalPopUp()}
    </React.Fragment>
  );
}
